import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import ReactModal from "react-modal";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {selectedPerson} from "../../../recoils/recoil";
import useApiRecords from "./apis/useApiRecords";

const BiographyViewPopup = ({propShowModal, handleCloseModal, tocId}) => {
    const { book_id } = useParams();
    const navigate = useNavigate();
    const [filteredDatas, setFilteredDatas] = useState([]);

    const data = useApiRecords(book_id, tocId);

    // getter
    const selectedPersonList = useRecoilValue(selectedPerson);
    // setter
    const setSelectedPersonList = useSetRecoilState(selectedPerson);

    useEffect(() => {
        if (!propShowModal) return;
        console.log(data);
        if(data !== null && data.toc_id === tocId) {
            setFilteredDatas(data.records);
        }
    }, [propShowModal, tocId, data]);

    const handlePersonClick = (order) => {
        // 중복된 person_id가 이미 존재하는 경우 추가하지 않음
        const exists = selectedPersonList.some(person => person.id === order.person_id);

        console.log(order)

        const updatedList = exists
            ? [...selectedPersonList] // 기존 순서 유지
            : [...selectedPersonList, {id: order.person_id, name: order.primaryname, nameKo: order.primaryname_ko}];

        setSelectedPersonList(updatedList);

        const idList = updatedList.map(person => person.id);

        // 배열에 넣어서 personId 보내기
        navigate(`/person/${idList}`);
    };

    return (
        <>
            <ReactModal
                isOpen={propShowModal}
                onRequestClose={handleCloseModal}
                contentLabel="First Modal"
                style={{
                    overlay: {
                        backgroundColor: "rgba(0, 0, 0, 0.5)", // 배경색
                        zIndex: 1000, // 첫 번째 모달의 z-index
                    },
                    content: {
                        width: "0",
                        height: "0",
                        margin: "auto",
                        borderRadius: "10px",
                    },
                }}
            >
                <div
                    className="wbz-popup-cont is-template"
                    id="biographyViewPopup"
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <div className="popup-header">
                        <b className="popup-title">{data?.toc_title}{data?.page_start && <span className="sub-tit">P.{data?.page_start}</span>}</b>
                        <button type="button" className="popup-close" onClick={handleCloseModal}>닫기</button>
                    </div>
                    <div className="popup-cont">
                        <div className="view-table">
                            {filteredDatas.map((record) => (
                                <>
                                    <div className="view-row" key={record.tocrecord_id}>
                                        <div className="page">
                                            <span>페이지</span>
                                            <span className="num">{(record.page_start === '' ? '-' : record.page_start)}</span>
                                        </div>
                                        <div className="record">{record.record_text}</div>
                                        {record.persons?.length > 0 && (
                                            <div className="legend-wrap">
                                                <ul className="legend-area">
                                                    <li>
                                                        <i className="person"></i>
                                                        <div className="legend-text">
                                                            {record.persons.map((person, index) => (
                                                                <span key={`person-${index}`}><button onClick={() => handlePersonClick(person)}>{person.primaryname}</button></span>
                                                            ))}
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                </>
                            ))}
                        </div>
                    </div>
                </div>
            </ReactModal>
        </>
    );
};

export default BiographyViewPopup;